import React, { useState, createContext, useCallback } from "react";

const ForwardMessageContext = createContext();

const ForwardMessageProvider = ({ children }) => {
	const [showSelectMessageCheckbox, setShowSelectMessageCheckbox] = useState(false);
	const [selectedMessages, setSelectedMessages] = useState([]);
	const [forwardMessageModalOpen, setForwardMessageModalOpen] = useState(false);

	const toggleSelectedMessage = useCallback((message) => {
		if (!message) return;
		setSelectedMessages((prev) => {
			const exists = prev.some((m) => m.id === message.id);
			if (exists) {
				return prev.filter((m) => m.id !== message.id);
			}
			return [...prev, message];
		});
	}, []);

	const clearSelection = useCallback(() => {
		setSelectedMessages([]);
		setShowSelectMessageCheckbox(false);
	}, []);

	return (
		<ForwardMessageContext.Provider
			value={{
				showSelectMessageCheckbox,
				setShowSelectMessageCheckbox,
				selectedMessages,
				setSelectedMessages,
				forwardMessageModalOpen,
				setForwardMessageModalOpen,
				toggleSelectedMessage,
				clearSelection,
			}}
		>
			{children}
		</ForwardMessageContext.Provider>
	);
};

export { ForwardMessageContext, ForwardMessageProvider };
